
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { mockCashbackTransactions } from "@/data/mockCustomerData";

interface CustomerCashbackTabProps {
  customerId: string;
}

export function CustomerCashbackTab({ customerId }: CustomerCashbackTabProps) {
  const transactions = mockCashbackTransactions.filter(tx => tx.customerId === customerId);
  
  // Calculate cashback balance
  const balance = transactions.reduce((total, tx) => {
    const value = parseFloat(tx.value.replace('R$ ', '').replace('.', '').replace(',', '.').replace('-', ''));
    return tx.type === 'earned' ? total + value : total - value;
  }, 0);

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Saldo de Cashback</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="p-4 rounded-lg border bg-muted/20">
            <div className="text-sm font-medium text-gray-500">Saldo Disponível</div>
            <div className="text-3xl font-bold">R$ {balance.toFixed(2).replace('.', ',')}</div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Histórico de Transações</CardTitle>
        </CardHeader>
        <CardContent>
          {transactions.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              Este cliente não possui transações de cashback.
            </div>
          ) : (
            <div className="rounded-md border">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Data</TableHead>
                    <TableHead>Descrição</TableHead>
                    <TableHead>Tipo</TableHead>
                    <TableHead>Valor</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {transactions.map((tx) => (
                    <TableRow key={tx.id}>
                      <TableCell>
                        {new Date(tx.date).toLocaleDateString('pt-BR')}
                      </TableCell>
                      <TableCell>{tx.description}</TableCell>
                      <TableCell>
                        <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${tx.type === 'earned' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}`}>
                          {tx.type === 'earned' ? 'Recebido' : 'Utilizado'}
                        </div>
                      </TableCell>
                      <TableCell className={tx.type === 'earned' ? 'text-green-700' : 'text-amber-700'}>
                        {tx.value}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
